import type { NuxtApp } from '#app'
import type { Country, Currency } from '@core/plugins/master-data/types'
import type {
  GQLHistoricalStats,
  GQLHistoricalStatsVariables,
} from './historical-stats/generated/historical-stats'
import QUERY from './historical-stats/historical-stats.graphql'

export async function queryHistoricalStats(
  nuxtApp: NuxtApp,
  params: {
    countryFrom: Country
    countryTo: Country
    currencyFrom: Currency
    currencyTo: Currency
  },
) {
  const { $apollo } = nuxtApp
  const { data, errors } = await $apollo.query<GQLHistoricalStats, GQLHistoricalStatsVariables>({
    query: QUERY,
    variables: {
      countryFromIso: params.countryFrom.iso,
      countryToIso: params.countryTo.iso,
      currencyFromIso: params.currencyFrom.iso,
      currencyToIso: params.currencyTo.iso,
    },
  })

  if (errors) {
    throw createGraphQLError(errors, 'Failed to load historical stats')
  }

  return data.historicalStats
}
